import { render, staticRenderFns } from "./OutsourceDetail.vue?vue&type=template&id=ffa244f0&scoped=true"
import script from "./OutsourceDetail.vue?vue&type=script&lang=js"
export * from "./OutsourceDetail.vue?vue&type=script&lang=js"
import style0 from "./OutsourceDetail.vue?vue&type=style&index=0&id=ffa244f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa244f0",
  null
  
)

export default component.exports